
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PremiumProductFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PremiumProductCollections_learningProduct"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockedCountries"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"catalogAvailabilityStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"degreeAttributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"degreeRequiresBachelorDegree"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasApplicationFee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasScholarship"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numCourses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numCredits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numModules"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfCohorts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onCampusTuition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onlineSameAsOnCampus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payAsYouGo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryAlignedJob"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qsRanking"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tuitionInUsd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"webinarHost"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"domainIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"launchDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partnerEntities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PremiumProductPartnerFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tagline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upcomingTermDates"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextAdmissionStartDate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nextAcademicTermStartDate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nextAdmissionDeadlineDate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nextAdmissionSubtermDeadlineDate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"programDeadlines"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationAdmissionTermName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"admissionStartDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtermDeadlineDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extendedSubtermDeadlineDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priorityDeadlineDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secondaryPriorityDeadlineDate"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1107}};
    doc.loc.source = {"body":"#import \"./PremiumProductPartnerFieldsFragment.graphql\"\n\nfragment PremiumProductFields on PremiumProductCollections_learningProduct {\n  blockedCountries\n  catalogAvailabilityStatus\n  categoryIds\n  degreeAttributes {\n    degreeRequiresBachelorDegree\n    hasApplicationFee\n    hasScholarship\n    numCourses\n    numCredits\n    numModules\n    numberOfCohorts\n    onCampusTuition\n    onlineSameAsOnCampus\n    payAsYouGo\n    primaryAlignedJob\n    qsRanking\n    tuitionInUsd\n    webinarHost\n  }\n  domainIds\n  id\n  imageUrl\n  languageCode\n  launchDate\n  name\n  partnerEntities {\n    ...PremiumProductPartnerFields\n  }\n  productVariant\n  shortName\n  slug\n  tagline\n  thumbnailUrl\n  upcomingTermDates {\n    nextAdmissionStartDate {\n      seconds\n    }\n    nextAcademicTermStartDate {\n      seconds\n    }\n    nextAdmissionDeadlineDate {\n      seconds\n    }\n    nextAdmissionSubtermDeadlineDate {\n      seconds\n    }\n  }\n  programDeadlines {\n    applicationAdmissionTermName\n    admissionStartDate\n    subtermDeadlineDate\n    extendedSubtermDeadlineDate\n    priorityDeadlineDate\n    secondaryPriorityDeadlineDate\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./PremiumProductPartnerFieldsFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PremiumProductFields"] = oneQuery(doc, "PremiumProductFields");
        
